import React from "react"

const ChargeContext = React.createContext(null as any)

export default ChargeContext